import React from 'react';

import { MFA_EMAIL_KEY } from 'lib/mfa';
import { ActionButton, ButtonV2, TextInput } from 'components';

function SetupEmail({ onPrevious, onContinue, email }) {
  const submit = async () => {
    try {
      const result = await req.mfaCreateAuthenticator({ kind: MFA_EMAIL_KEY, identifier: email });
      onContinue({ otpSecret: result.otp_secret });
    } catch {
      Actions.reportError('Unable to send verification code');
    }
  };

  return (
    <>
      <div className="modal__header mfa-add-method">
        <div className="modal__header-title">
          <ActionButton data-testid="backArrow" iconName="back" size={14} onClick={onPrevious} />
          Set Up Email{' '}
          <label>
            <strong>Step 2</strong> / 3
          </label>
        </div>
      </div>
      <div className="modal__container">
        <div className="mfa-add-method__description">
          We have pre-populated the email address from your account. This email will be used to deliver verification
          codes to help validate your identity.
        </div>
        <div className="mfa-add-method__label">Email Address</div>
        <TextInput className="mfa-add-method__placeholder" defaultValue={email} disabled />
        <div className="mfa-add-method__footnote">Procare will never share or market to this information.</div>
      </div>
      <div className="modal__footer">
        <ButtonV2 data-testid="verifyEmailButton" className="button--primary" label="Verify Email" onClick={submit} />
      </div>
    </>
  );
}

export default SetupEmail;
